import { isChampionshipReleased } from '@/lib/championship-publishing-status'

function toValidDate(value) {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function getEffectiveRecruitmentOpenDateTime(championship, event) {
  const eventOverride = toValidDate(event?.recruitmentOpenDateTime)
  if (eventOverride) return eventOverride

  const hasOffset =
    championship?.recruitmentOpenOffsetMinutes !== null &&
    championship?.recruitmentOpenOffsetMinutes !== undefined
  const offsetMinutes = Number(championship?.recruitmentOpenOffsetMinutes)
  const eventStart = toValidDate(event?.startDateTime)
  if (hasOffset && Number.isFinite(offsetMinutes) && eventStart) {
    return new Date(eventStart.getTime() - offsetMinutes * 60 * 1000)
  }

  const events = Array.isArray(championship?.events) ? championship.events : []
  if (
    !event &&
    hasOffset &&
    Number.isFinite(offsetMinutes) &&
    events.length > 0
  ) {
    const eventOpenTimes = events
      .map((item) => getEffectiveRecruitmentOpenDateTime(championship, item))
      .filter(Boolean)
      .sort((a, b) => a.getTime() - b.getTime())

    if (eventOpenTimes.length > 0) return eventOpenTimes[0]
  }

  return (
    toValidDate(championship?.recruitmentOpenDateTime) ||
    toValidDate(championship?.releaseDateTime)
  )
}

export function canRecruitForEvent(championship, event, now = new Date()) {
  if (!championship?.isRecruiting) return false
  if (!isChampionshipReleased(championship, now)) return false

  const recruitmentOpenDateTime = getEffectiveRecruitmentOpenDateTime(
    championship,
    event,
  )
  if (!recruitmentOpenDateTime) return true

  return recruitmentOpenDateTime <= now
}

export function canRecruitForChampionship(championship, now = new Date()) {
  return canRecruitForEvent(championship, null, now)
}
